const timeSeries = {
  queryState: {
    projectMetaLoadFailed: "지도 정보를 불러오지 못했습니다",
    mappingImageListLoadFailed: "이미지를 불러오지 못했습니다",
    mappingImageListNotLoaded: "아직 이미지를 불러오지 않았습니다",
    issueListLoadFailed: "이슈 목록을 불러오지 못했습니다",
    projectNotSelected: "조회할 프로젝트가 지정되지 않았습니다",
  },
  clip: {
    title: "절단면 도구",
    count: "전체 {{count}}개",
    addClipping: "단면 추가",
    clippingList: "단면 목록",
    box: "박스",
    plane: "평면",
    boxName: "박스 {{index}}",
    planeName: "평면 {{index}}",
    addBySurfaceClick: "표면 클릭으로 추가",
    placingHint: "3D 화면에서 모델 표면을 클릭하세요",
    placingCancel: "우클릭 또는 ESC로 취소",
    limitNotice: "동시 적용은 최대 {{max}}개까지 가능합니다",
    emptyList: "추가된 단면이 없습니다.",
    emptyListDesc: "위에서 단면을 추가하세요.",
    toggleItem: "단면 표시",
    toggleItemNamed: "{{name}} 표시",
    itemGroupNamed: "{{name}} 설정",
    deleteNamed: "{{name}} 삭제",
    deleteTitle: "단면 삭제",
    deleteConfirm: "'{{name}}' 단면을 삭제하시겠습니까?",
    deleteIrreversible: "삭제한 단면은 복구할 수 없습니다.",
    deleteCancel: "취소",
    deleteConfirmAction: "삭제",
    sizeLabel: "한 변",
    namePlaceholder: "단면 이름",
    nameInputLabel: "이름",
    renameNamed: "{{name}} 이름 변경",
    renameTitle: "단면 이름 변경",
    renameConfirm: "변경",
    renameCancel: "취소",
    delete: "삭제",
    disabledTitle: "꺼진 단면입니다",
    disabledDesc: "스위치를 켜서 사용하세요",
    editMode: "편집",
    editTooltipMain: "꼭짓점 · 면을 직접 잡아 형태 변경",
    editTooltipSub: "끄면 모델을 잡고 카메라 이동",
    wireframe: "모서리",
    capFill: "단면 색칠",
    invert: "반전",
    save: "저장",
    unsavedChanges: "저장되지 않은 변경",
    loading: "단면 목록을 불러오는 중…",
    loadFailed: "단면 목록을 불러오지 못했습니다",
    retry: "다시 시도",
    saveFailed: "저장에 실패했습니다. 다시 시도해주세요.",
    horizontal: "수평",
    vertical: "수직",
    gap: "간격",
    area: "면적",
    rotation: "회전",
    tilt: "기울기",
    reset: "초기화",
    undo: "실행 취소",
    redo: "다시 실행",
  },
  page: {
    title: "시계열 점검",
  },
  sidebar: {
    layers: "레이어",
    projectInfo: "프로젝트 정보",
    issues: "이슈",
    report: "리포트",
  },
  modal: {
    issueInfo: "이슈 정보",
    crossSection: "선형 단면도",
  },
  map: {
    satelliteMap: "위성 지도",
    viewerCount: "뷰어 개수",
    imageList: "이미지 리스트",
    favoriteOnly: "즐겨찾기만 보기",
    standard: "기준",
    noImages: "이미지가 없습니다",
    nearbyImagesOnly: "근방 100m까지 사진이 표시됩니다",
  },
  drawingTools: {
    draw: "생성",
    edit: "편집",
    etc: "기타",
  },
  toolbar3d: {
    create: "생성",
    measurement: "측정",
    howToUse: "이용 방법",
    backgroundColor: "배경색 변경",
    resetView: "초기 화면",
  },
  mapTool: {
    tool: {
      splitView: "화면 분할",
      splitViewCount: "{{count}}분할 화면",
      fullscreen: "전체 화면",
      exitFullscreen: "전체 화면 종료",
      zoomIn: "확대",
      zoomOut: "축소",
      marker: "점",
      multiMarker: "다중 점",
      line: "선",
      polygon: "면",
      rectangle: "사각형",
      text: "글자",
      modify: "꼭짓점 수정",
      move: "이동",
      delete: "삭제",
      distance: "거리 측정",
      orthogonal: "수직 측정",
      area: "면적 측정",
      profile: "종단 측정",
      remover: "측정 지우개",
      droneImage: "드론 이미지",
      areaCapture: "영역 캡쳐",
      annotationTitle: "이슈 이름 표시",
    },
    autoIssueName: "이슈 {{n}}",
    issueLayerOn: {
      notice: "이슈 레이어가 켜졌습니다",
    },
    deleteConfirm: {
      cancel: "취소",
      subtitle: '"{{name}}" 이슈를 삭제할까요?',
      irreversible: "삭제한 이슈는 되돌릴 수 없습니다",
    },
  },
  messages: {
    annotationCreated: "어노테이션 생성 완료",
    annotationUpdated: "어노테이션 수정 완료",
    annotationDeleted: "어노테이션 삭제 완료",
    annotationCreateFailed: "어노테이션 생성 실패",
    annotationUpdateFailed: "어노테이션 수정 실패",
    annotationDeleteFailed: "어노테이션 삭제 실패",
    issueDeleted: "이슈가 삭제되었습니다.",
    issueDeleteFailed: "이슈 삭제에 실패했습니다.",
    issueDeleteFailedForUsage:
      "선택한 이슈는 다른 어노테이션에서 사용중입니다.",
    selectDateToDelete: "삭제할 날짜를 선택해주세요.",
  },
  deleteModal: {
    title: "이슈 삭제",
    confirmMessage: "정말 이슈를 삭제하시겠습니까?",
    delete: "삭제",
  },
  layerDeleteModal: {
    title: "레이어 삭제",
    delete: "삭제",
    cancel: "취소",
    enterEditMode: "레이어 삭제",
    deleteSuccess: "레이어가 삭제되었습니다.",
    deleteFailed: "레이어 삭제에 실패했습니다.",
  },
  annotationVisibilityConfirm: {
    title: "어노테이션 표시가 꺼져 있습니다",
    subTitle:
      "선택한 이슈를 보려면 어노테이션 표시를 켜야 합니다. 켜시겠습니까?",
    confirm: "켜기",
    cancel: "취소",
  },
  issue: {
    create: "이슈 생성",
    filter: "필터",
    empty: "이슈가 없습니다",
    total: "전체",
    reset: "초기화",
    apply: "적용",
    cancel: "취소",
    save: "저장",
    delete: "삭제",
    edit: "수정",
    export: "이슈 내보내기",
    exportTitle: "분석 시계열 선택",
    exportDescription:
      "원하는 시계열을 선택한 뒤, 확인 버튼을 누르면 날짜별로 측정값을 비교함으로써 시간이 지남에 따라 이슈의 진행도 및 악화도를 확인할 수 있습니다.",
    exportHint: "입력하지 않은 항목이 있습니다. 전체 내용을 작성해 주세요.",
    noData: "사용 가능한 시계열 데이터가 없습니다.",
    linkFailed: "이슈 연계 실패",
    confirm: "확인",
    commentCount: "댓글 {{count}}개",
    unexportTitle: "이슈 내보내기 해제",
    unexportConfirm: "{{dates}} 의 이슈가 삭제됩니다.",
    unexportIrreversible:
      "삭제된 이슈는 복구할 수 없습니다. 해당 날짜의 등급·좌표 편집 내용도 함께 사라집니다.",
    unexportAction: "해제",
    applying: "이슈 내보내기 적용 중",
    applySuccess: "이슈 연계 성공",
    partialFailure: "일부 항목을 처리하지 못했습니다. ({{count}}건)",
  },
  form: {
    type: "주석 타입",
    name: "이름",
    fontSize: "폰트 크기",
    size: "사이즈(px)",
    color: "색상",
    opacity: "투명도",
    position: "위치",
    lonlat: "경위도",
    xCoord: "x좌표",
    yCoord: "y좌표",
    issue: "이슈 유형",
    category: "분류 기준",
    categoryPlaceholder: "분류 기준 선택",
    grade: "강도",
    gradePlaceholder: "선택",
    memo: "메모",
    photo: "사진",
  },
  layer: {
    noModels: "구축된 모델이 없습니다",
    orthomosaic: "정사영상",
    dsm: "수치표면모델",
    stratum: "층 레이어",
    design: "설계 레이어",
    line: "선형 레이어",
    longitudinal: "종단면",
    crossSection: "횡단면",
    crossSectionList: "저장된 횡단면",
    specificCrossSection: "특정 횡단면",
  },
  export: {
    shootingDate: "촬영일",
    ground: "지반고",
    plan: "계획고",
    stratum: "지층",
    selectDate: "날짜 선택",
    selectFile: "파일 선택",
    create: "생성",
    creating: "생성 중...",
    alertMessage:
      "처리 완료된 파일만 사용할 수 있으며, 파일 생성은 요청 이후 최대 10분 이내에 완료됩니다.\n토공 집계표: 계획고를 선택하지 않으면, 선택한 설계지반고와 현황 드론 지반고의 차이로 잔여 수량을 계산합니다.",
    noSection: "선택된 섹션이 없습니다.",
    createStarted: "파일 생성이 시작되었습니다.",
    notFound: "횡단면 데이터를 찾을 수 없습니다.",
    createFailed: "파일 생성에 실패했습니다.",
    downloadTooltip:
      "다운로드 버튼을 누르면 횡단면 정보를\nCSV 등 다양한 형식의 파일로 내보낼 수 있습니다.",
  },
  projectInfo: {
    title: "정보",
    edit: "편집",
    project: "프로젝트",
    mapping: "매핑",
  },
  issueList: {
    title: "이슈",
    total: "총 이슈",
    create: "이슈 생성",
    filter: "필터",
    noIssues: "등록된 이슈가 없습니다",
    noFilteredIssues: "필터링된 이슈가 없습니다",
    flyTo: "이슈로 이동",
    flyToAria: "{{name}} 이슈로 이동",
    notInCurrentTimeSeriesTitle: "현재 시계열에 없는 이슈",
    notInCurrentTimeSeriesBody:
      "현재 시계열에는 이 이슈가 존재하지 않습니다. 이슈 정보의 '이슈 내보내기'로 현재 시계열에 이슈를 생성할 수 있습니다.",
    openIssueInfo: "이슈 정보 열기",
    close: "닫기",
  },
  layerFlyTo: {
    label: "도면으로 이동",
    aria: "{{name}} 도면으로 이동",
    blockedFar:
      "현장에서 약 {{distance}} km 떨어져 있어 이동하지 않습니다. 파일의 좌표계를 확인하세요.",
    blockedUnresolvable: "레이어 범위를 해석할 수 없어 이동하지 않습니다.",
  },
  issueDetail: {
    grade: "이슈 강도",
    type: "이슈 유형",
    tool: "어노테이션 툴",
    created: "이슈 생성일",
    updated: "이슈 수정일",
    creator: "최초 생성자 ID",
    gradeTrend: "이슈 강도 추이",
    noDate: "날짜 없음",
    notInTimeSeries: "이 이슈는 선택된 기준 시계열에 없습니다.",
    linkToTimeSeries:
      "기준 시계열 변경 혹은 기준 시계열에 이슈를 연계해주세요.",
  },
  measurement: {
    coordinates: "좌표",
    coordinatesFile: "좌표정보",
    measurementFile: "측정정보",
    volumeFile: "체적정보",
    line: "선 정보",
  },
  transferList: {
    timeSeriesList: "시계열 리스트",
    selectedTimeSeries: "선택 시계열",
    selectAll: "전체 선택",
    standard: "기준",
    export: "내보내기",
  },
  issueTypeModal: {
    title: "이슈 유형 관리",
    close: "모달 닫기",
    searchPlaceholder: "검색어를 입력해주세요",
    addType: "유형 추가",
    issueName: "이슈 이름",
    add: "추가",
    enterName: "이슈 유형 이름을 입력해주세요.",
    typeAdded: "새 이슈 유형이 추가되었습니다.",
    addFailed: "이슈 유형 추가에 실패했습니다.",
  },
  profile: {
    title: "프로파일",
    close: "닫기",
    resetView: "화면 초기화",
    overflowMenu: "더보기",
    copyCoordinate: "좌표 복사",
    copied: "복사됨",
    copyFailed: "복사하지 못했습니다",
    copyHint: "그래프를 클릭하면 좌표를 복사할 수 있습니다",
    fullscreen: "전체 화면",
    exitFullscreen: "전체 화면 종료",
    themeToggleToLight: "라이트 테마",
    themeToggleToDark: "다크 테마",
    labelMode: {
      prefix: "라벨",
      hover: "호버",
      on: "고정",
      tooltipHover: "라벨 호버 표시",
      tooltipOn: "라벨 고정 표시",
    },
    opacity: {
      label: "모달 투명도",
      tooltip: "모달 투명도 조절",
    },
    colorMode: {
      prefix: "색상",
      model: "모델",
      real: "실사",
      tooltipModel: "각 모델을 고유 색상으로 표시",
      tooltipReal: "3D 모델의 원본 색상으로 표시",
    },
    colorModes: {
      realistic: "실사",
      model: "모델",
      modelByModel: "모델별",
      comingSoon: "coming soon",
    },
    capture: {
      tooltip: "이미지 캡처",
      formats: {
        png: "PNG",
        jpg: "JPG",
        jpeg: "JPEG",
        webp: "WEBP",
      },
    },
    measureTools: {
      point: "점 측정",
      polyline: "직선 측정 (클릭으로 점 추가, 우클릭으로 확정)",
      axes: "축 측정 (다수 수직·수평 교차점 측정)",
      rectangle: "그리드 측정",
      circle: "원 측정",
      erase: "측정 삭제",
      eraseSelect: "선택 삭제",
      eraseSelectHint: "측정 점/도형/라벨을 클릭해 개별 삭제",
      eraseAll: "전체 삭제",
      eraseAllHint: "프로파일 그래프 위 모든 측정 삭제",
    },
    colorModePopover: {
      title: "색상 모드",
      realisticHint: "캡처된 원본 색상 그대로 표시합니다.",
      modelHint: "각 모델을 고유 색상으로 표시합니다. 모델 필터 사용 가능.",
    },
    modelFilter: {
      title: "모델 필터",
      modeOnly: "모델별 모드에서만 사용할 수 있습니다.",
      empty: "표시할 모델이 없습니다.",
    },
    modelLegend: {
      ariaList: "모델 색상 범례",
      toggleHide: "단면 숨기기",
      toggleShow: "단면 표시",
    },
    axis: {
      distance: "거리 (m)",
      orthoHeight: "높이 (m)",
      deltaHeight: "Δ높이",
      deltaDistance: "Δ거리",
    },
    coordinateLabels: {
      longitude: "경도",
      latitude: "위도",
      ellipsoidHeight: "타원체고",
    },
    coordSystemWarning: {
      unsupportedEpsg:
        "지원하지 않는 좌표계(EPSG:{epsg}) 프로젝트입니다. KOREA2000 좌표 표시는 사용할 수 없습니다.",
    },
    loading: {
      capturing: "단면 생성 중...",
      captureFailed: "단면 이미지 로드 실패",
    },
    empty: {
      noIntersection: "단면과 교차하는 BIM/Mesh 모델을 찾지 못했습니다.",
    },
    metrics: {
      sharpness: "선명도",
      accuracy: "정확도",
      confidence: "신뢰도",
      tooltips: {
        sharpness:
          "단면 이미지의 픽셀 크기. 값이 클수록 줌인 시 더 선명하게 보입니다. 측정 정확도와는 무관하며, 디스플레이 픽셀 밀도(DPR)와 패널 크기에 따라 달라집니다.",
        accuracy:
          "프로젝트 3D 모델의 GSD 기반 이론적 측정 한계. 모델 자체의 픽셀 분해능에서 비롯됩니다.",
        confidence:
          "실제 측정 시 신뢰할 수 있는 보수적 오차 범위. GSD의 약 2배로 추정됩니다.",
      },
    },
    // 어노테이션 횡단면 전체 추출 — 패널(선택지·확인 모달·칩)과 측정 탭 내보내기 기록
    fullExport: {
      currentStation: "현재 스테이션 추출",
      currentStationDescription: "현재 스테이션 1개를 바로 다운로드합니다.",
      allStationsTitle: "전체 스테이션 추출",
      allStationsDescription: "추출 결과는 이 패널의 내보내기 기록에 저장되고, 거기서 CSV·DXF를 다운로드할 수 있습니다.",
      confirmTitle: "전체 스테이션 추출",
      confirmMessage: "결과는 이 패널의 내보내기 기록에서 다운로드할 수 있습니다.",
      stationCount: "스테이션",
      start: "추출 시작",
      started: "전체 스테이션 추출을 시작했습니다.",
      tooLargeSectionLength: "작업량이 상한을 넘습니다 — {{axis}} {{actual}} / 최대 {{maximum}}. 횡단 간격을 넓히거나, 선분 범위·폭 설정을 줄이거나, 켜진 레이어를 줄여 주세요.",
      tooLargeSamples: "작업량이 상한을 넘습니다 — {{axis}} {{actual}} / 최대 {{maximum}}. 점 간격·횡단 간격을 넓히거나, 선분 범위·폭 설정을 줄이거나, 켜진 레이어를 줄여 주세요.",
      tooLargeUnknownAxis: "작업량이 상한을 넘습니다 — {{axis}} {{actual}} / 최대 {{maximum}}.",
      axisSectionLength: "단면 길이 합(m) × 레이어 수",
      axisSamples: "점 총수",
      inProgress: "이 어노테이션의 전체 스테이션 추출이 이미 진행 중입니다. 내보내기 기록에서 확인해 주세요.",
      capacityReached: "지금은 전체 스테이션 추출 요청이 많습니다. 잠시 뒤 다시 시도해 주세요.",
      startFailed: "전체 스테이션 추출을 시작하지 못했습니다.",
      fileSuffix: "전체",
    },
    exportHistory: {
      title: "내보내기 기록",
      buttonRunning: "내보내기 기록 · {{percent}}%",
      buttonCompleted: "내보내기 기록 · 완료",
      buttonFailed: "내보내기 기록 · 실패",
      empty: "전체 스테이션 추출 결과를 여기서 다운로드할 수 있습니다.",
      loadFailed: "내보내기 기록을 불러오지 못했습니다.",
      summary: "스테이션 {{stations}} · 점 간격 {{step}} m · 레이어 {{series}}",
      sectionSettings: "구간 {{first}}–{{last}} · 시작 측점 {{start}} m · 횡단 간격 {{interval}} m · 좌/우 {{left}}/{{right}} m",
      completed: "완료",
      failed: "실패",
      detailsLabel: "{{time}} 기록({{status}}) 세부 정보",
      progressLabel: "전체 스테이션 추출 진행률",
      downloadCsv: "{{time}} 기록 CSV 다운로드",
      downloadDxf: "{{time}} 기록 DXF 다운로드",
      delete: "삭제",
      deleteLabel: "{{time}} 기록 삭제",
      notFound: "기록을 찾을 수 없습니다.",
      downloadFailed: "파일을 만들지 못했습니다.",
      deleteFailed: "기록을 삭제하지 못했습니다.",
    },
  },
  report: {
    title: "리포트",
    create: "리포트 생성",
    export: "리포트 내보내기",
    formTitle: "제목",
    titlePlaceholder: "리포트의 제목을 입력해주세요",
    author: "작성자",
    authorPlaceholder: "작성자를 입력해주세요",
    organization: "소속",
    job: "직무",
    email: "이메일",
    phone: "H.P",
  },
  vector: {
    title: "벡터",
    totalCount: "전체 {{count}}개",
    showOnMap: "지도에 표시",
    create: {
      sectionTitle: "벡터 생성",
      open: "좌표 입력으로 생성",
      name: "이름",
      namePlaceholder: "벡터 이름",
      modeLngLat: "위도/경도",
      modeProjectCrs: "X/Y 좌표",
      lng: "경도",
      lat: "위도",
      x: "X",
      y: "Y",
      elHeight: "높이(m)",
      color: "색상",
      radius: "반지름(m)",
      shape: "형태",
      shape_line: "선",
      shape_cylinder: "원기둥",
      shape_square: "사각기둥",
      side: "한 변(m)",
      shapeLineNoSize: "선은 크기 없음",
      radiusValueHint: "값 입력",
      commentPlaceholder: "메모를 입력하세요 (선택)",
      addPoint: "점 추가",
      submit: "생성",
      epsgUnavailable: "프로젝트 좌표계를 확인할 수 없습니다.",
      createFailed: "벡터 생성에 실패했습니다.",
    },
    list: {
      sectionTitle: "벡터 목록",
      empty: "생성된 벡터가 없습니다.",
      emptyDesc: "위에서 좌표를 입력해 생성하세요.",
      loading: "벡터를 불러오는 중…",
      loadFailed: "벡터를 불러오지 못했습니다.",
      retry: "다시 시도",
      radius: "반지름(m)",
      line: "선",
      radiusValue: "{{symbol}} {{value}}m",
      pointCount: "점 {{count}}개",
      delete: "삭제",
      deletePoints: "점 삭제",
      deleteConfirmTitle: "벡터 삭제",
      deleteConfirmMessage: "'{{name}}' 벡터를 삭제하시겠습니까?",
      deleteIrreversible: "삭제 후에는 되돌릴 수 없습니다.",
      deleteFailed: "벡터 삭제에 실패했습니다.",
      updateFailed: "벡터 수정에 실패했습니다.",
      infoSection: "정보",
      coordinates: "좌표 목록",
      perpendicular: "수직 단면",
      save: "저장",
      reset: "초기화",
    },
    perpendicular: {
      title: "수직 단면",
      position: "절단 위치 (시작점에서 거리, m)",
      totalLength: "전체 길이 {{length}}m",
      meterUnit: "m",
      positionRange: "절단 위치는 0 이상 전체 길이 이하여야 합니다.",
      length: "절단선 길이(m)",
      confirm: "확인",
      lengthRange: "길이는 0 초과 1000 이하여야 합니다.",
      invalid:
        "절단선을 계산할 수 없습니다.\n수직이거나 한 점인 벡터는 단면을 만들 수 없습니다.",
    },
    selection: {
      selectDelete: "삭제",
      selectAll: "전체 선택",
      deselectAll: "선택 해제",
      confirm: "확인",
      confirmMessage: "{{count}}개의 벡터를 삭제하시겠습니까?",
      minPointsHint: "점은 최소 {{count}}개 남아야 합니다",
    },
    errors: {
      nameLength: "이름은 {{nameMin}}~{{nameMax}}자여야 합니다.",
      commentLength: "메모는 {{commentMax}}자 이하여야 합니다.",
      minPoints: "점은 최소 {{minPoints}}개 필요합니다.",
      maxPoints: "점은 최대 {{maxPoints}}개까지 입력할 수 있습니다.",
      notNumber: "숫자를 입력해 주세요.",
      lngRange: "경도는 {{lngMin}}~{{lngMax}} 범위여야 합니다.",
      latRange: "위도는 {{latMin}}~{{latMax}} 범위여야 합니다.",
      radiusRange:
        "반지름은 {{sizeExclusiveMin}} 초과 {{maxRadius}} 이하여야 합니다.",
      sideRange:
        "한 변은 {{sizeExclusiveMin}} 초과 {{maxSide}} 이하여야 합니다.",
    },
  },
  geoLog: {
    title: "사진·영상",
    totalCount: "전체 {{count}}개",
    showOnMap: "지도에 표시",
    noFilesHint: "지도가 로드되면 파일이 표시됩니다.",
    emptyFiles: "등록된 사진·영상이 없습니다.",
    noPosition: "위치 없음",
    groupCount: "{{count}}개",
    locationGroup: {
      noPositionDesc: "아직 지도에 표시되지 않은 사진입니다.",
    },
    uncategorized: "미분류",
    noCaptureDate: "촬영일 없음",
    uploaderMe: "나",
    groupEdit: {
      title: "그룹 일괄 수정",
      label: "그룹 일괄 수정",
      titleField: "{{field}} 일괄 수정",
      desc: "이 그룹의 사진 {{count}}장에 같은 {{field}} 값을 한 번에 적용합니다.",
    },
    view: {
      captureDate: "촬영 날짜별",
      category: "주제별",
      uploader: "등록자별",
      locationName: "위치별",
    },
    sort: {
      latest: "최신순",
      oldest: "오래된순",
    },
    position: {
      modalTitle: "위치 설정",
      placeCard: "위치 지정",
      placeHint: "지도에 지정",
      clearCard: "위치 해제",
      clearHint: "선택 후 제거",
      attachCard: "기존 위치에 추가",
      attachHint: "기존 위치에 합치기",
      unnamedLocation: "이름 없는 위치",
      existingCount: "기존 {{count}}장",
      addAction: "여기에 추가",
      selectTargetHint:
        "이미 위치가 지정된 지점에 다른 사진을 함께 관리할 수 있습니다.\n사진을 추가할 기존 위치를 먼저 선택하세요.",
      placeStepHint:
        "지도의 빈 곳을 클릭하면 새 위치, 기존 마커를 클릭하면 그 위치에 추가됩니다.\n지정할 사진을 선택하세요.",
      clearStepHint:
        "사진에 지정된 위치를 해제해 위치 없음으로 되돌릴 수 있습니다.\n위치를 해제할 사진을 선택하세요.",
      attachStepHint:
        "선택한 사진을 이 위치로 모아 같은 지점에 표시할 수 있습니다.\n이 위치에 추가할 사진을 선택하세요.",
      noLocation: "지정된 위치가 없습니다",
      back: "뒤로",
      selectAll: "전체 선택",
      deselectAll: "선택 해제",
      placeEmpty: "위치를 지정할 사진이 없습니다",
      clearEmpty: "위치가 지정된 사진이 없습니다",
    },
    toolbar: {
      upload: "업로드",
      place: "위치 설정",
      delete: "삭제",
      download: "다운로드",
    },
    upload: {
      modalTitle: "업로드",
      fileCard: "파일 업로드",
      fileCardHint: "기기에서 파일 선택",
      folderCard: "폴더 업로드",
      folderCardHint: "폴더 전체 선택",
      mapCard: "지도 위로 업로드",
      mapCardHint: "지도에 끌어다 놓기",
      dropZoneHint: "또는 파일·폴더를 여기로 끌어다 놓으세요",
      dropActive: "여기에 놓으면 업로드됩니다",
      sizeLimit: "한 번에 최대 {{limit}}까지 업로드할 수 있습니다",
      uploading: "업로드 진행중...",
      uploadingShort: "업로드중",
      queued: "대기",
      cancel: "취소",
    },
    selection: {
      count: "{{count}}개 선택",
      selectGroup: "그룹 전체 선택",
      confirm: "지도에 지정",
      deleteTitle: "파일 삭제",
      deleteIrreversible: "삭제된 파일은 복구할 수 없습니다.",
      delete: "삭제",
      cancel: "취소",
      clear: "위치 해제",
      deleteConfirm: "선택한 {{count}}개 파일을 삭제하시겠습니까?",
      download: "다운로드",
      selectDelete: "선택 삭제",
      selectDownload: "선택 다운로드",
      downloadTitle: "파일 다운로드",
      downloadConfirm: "선택한 {{count}}개 파일을 다운로드하시겠습니까?",
    },
    edit: {
      date: "날짜",
      category: "주제",
      categoryPlaceholder: "주제 선택 또는 입력",
      locationName: "위치명",
      locationNamePlaceholder: "예: 1번 교각, 동측 진입로",
      save: "저장",
      reset: "되돌리기",
      cancel: "취소",
    },
    cell: {
      moveToPosition: "위치로 이동",
      setPosition: "위치 지정",
      detail: "상세보기",
      moveToPositionAria: "{{name}} 위치로 이동",
      setPositionAria: "{{name}} 위치 지정",
      detailAria: "{{name}} 상세보기",
    },
    detail: {
      uploader: "등록자",
      fileSize: "용량",
      locationJoinPlaceholder: "기존 위치명 선택",
      locationJoinHint:
        "이미 존재하는 위치로 저장됩니다. 새로운 위치 지정은 우측 상단 '위치 지정' 버튼을 사용하세요.",
      locationMoveHint: "선택한 위치로 이 사진만 이동합니다.",
      locationAssignHint: "현재 위치에 새 위치명으로 저장됩니다.",
      locationRenameGuide:
        "위치명은 위치의 이름입니다. 이름 변경은 지도 미리보기 카드(✎) 또는 사이드바의 위치별 보기의 그룹 편집에서 할 수 있으며, 그 위치의 모든 사진에 적용됩니다.",
      captureDate: "촬영일",
      category: "주제",
      locationName: "위치명",
      viewPosition: "위치 확인",
      viewPositionShort: "위치 확인",
      movePosition: "이동",
      movePositionAria: "위치 이동",
      expand: "크게 보기",
      collapse: "작게 보기",
    },
    pano: {
      view360: "360°",
      viewFlat: "2D",
      resetView: "초기 화면",
      play: "재생",
      pause: "일시정지",
      mute: "음소거",
      unmute: "음소거 해제",
      seek: "재생 위치",
    },
    roadview: {
      label: "로드뷰",
      enter: "로드뷰",
      exit: "로드뷰 종료",
      previous: "이전 지점",
      next: "다음 지점",
      moveToPoint: "{{ordinal}}번 지점으로 이동",
      progress: "{{current}} / {{total}}",
      miniMap: "세션 미니맵",
      departedPoint: "직전 지점",
      currentPoint: "현재 지점",
      departedDirection: "직전 지점 방향",
      relation: {
        previous: "직전 지점",
        next: "다음 지점",
        spatial: "공간 인접",
      },
      compass: {
        n: "북",
        ne: "북동",
        e: "동",
        se: "남동",
        s: "남",
        sw: "남서",
        w: "서",
        nw: "북서",
      },
      dualFisheye: "스티칭되지 않은 원본이라 360°로 열 수 없습니다",
    },
    card: {
      close: "닫기",
      previewClose: "미리보기 닫기",
      loadFailed: "불러오지 못했습니다",
      unplayableVideo: "이 브라우저에서 재생할 수 없는 영상 형식이에요. 다운로드해서 확인해 주세요.",
      download: "다운로드",
      deleteFile: "파일 삭제",
      deleteFileConfirm: "파일을 삭제하시겠습니까?",
      deleteScopePrompt: "삭제 대상",
      scopePrompt: {
        place: "위치 수정 대상",
        clear: "위치 해제 대상",
      },
      clearAllConfirm: "이 위치의 {{count}}장 위치를 모두 해제하시겠습니까?",
      scopeThis: "이 사진만",
      scopeAll: "전체 {{count}}장",
      positionSetting: "위치 설정",
      editPosition: "위치 수정",
      editPositionShort: "위치 수정",
      editLocationName: "위치명 수정",
      clearPosition: "위치 해제",
      clearPositionShort: "위치 해제",
      clearPositionConfirm: "위치를 해제하시겠습니까?",
      release: "해제",
      delete: "삭제",
      cancel: "취소",
      detail: "상세 보기",
      prevFile: "이전 파일",
      nextFile: "다음 파일",
      addHere: "이 위치에 사진 추가",
      addPhoto: "사진 추가",
      addPhotoShort: "사진 추가",
      addHereSelect: "이 위치에 추가할 파일 선택 ({{count}})",
    },
    marker: {
      placeHint: "지도를 클릭해 위치 지정 · 기존 마커 클릭 시 그 위치에 추가",
      mapUploadHint: "지도 위 원하는 위치에 파일·폴더를 끌어다 놓으세요",
      rightClickCancel: "우클릭 취소",
      single: "{{name}} 마커",
      cluster: "사진·영상 {{count}}개 마커",
      addToHere: "{{name}} 이 위치에 추가",
    },
    notice: {
      onlyGeoLog: "이미지·영상 파일만 업로드할 수 있습니다",
      emptyFile: "빈 파일은 업로드할 수 없습니다",
      excludedNonGeoLog: "이미지·영상이 아닌 파일 {{count}}개는 제외했습니다",
      dropOnModel: "모델 위에 드롭해주세요",
      placeFailed: "위치 지정에 실패했습니다",
      uploadFailed: "업로드에 실패했습니다",
      alreadyUploading: "이미 업로드 중인 파일 {{count}}개를 건너뛰었습니다",
      uploadTooLarge: "한 번에 업로드 가능한 용량 {{limit}}를 초과했습니다",
      quotaExceeded: "총 용량 {{limit}}를 초과하여 업로드할 수 없습니다",
      usageUnknown: "저장 용량을 확인할 수 없어 업로드할 수 없습니다",
      partialExcluded: "{{count}}개 파일을 제외하고 업로드합니다 ({{detail}})",
      allExcluded: "업로드할 수 있는 파일이 없습니다 ({{detail}})",
      excludeReason: {
        empty: "0바이트",
        nonMedia: "지원하지 않는 형식",
        invalidName: "파일명 오류",
        tooLarge: "용량 초과",
      },
      deleteFailed: "파일 삭제에 실패했습니다",
      listFailed: "목록을 불러오지 못했습니다",
      clearFailed: "위치 해제에 실패했습니다",
      addFailed: "사진 추가에 실패했습니다",
      updateMetaFailed: "정보 수정에 실패했습니다",
      updateMetaSaved: "정보가 저장되었습니다",
      downloadFailed: "다운로드에 실패했습니다",
      loadFailed: "목록을 불러오지 못했습니다",
      retry: "다시 시도",
    },
    scope: {
      drawArea: "영역 필터",
      addArea: "영역 추가",
      hint: "지도에 영역을 그리거나 마커를 클릭하면 그 영역의 사진·영상만 볼 수 있습니다. 지도에서 영역을 다시 클릭하면 선택한 영역에서 제외됩니다.",
      help: "영역 필터 도움말",
      areas: "영역 {{count}}개",
      areaLabel: "영역 {{n}}",
      count: "{{count}} / {{total}}",
      countAria: "전체 {{total}}개 중 {{count}}개 표시",
      drawing: "영역을 그리는 중…",
      drawCancel: "그리기 취소",
      drawingHint:
        "지도를 드래그해 영역을 그리세요. ESC 또는 우클릭으로 취소할 수 있습니다.",
      dragOnGround: "네 모서리가 모두 지면 위에 오도록 그려 주세요",
      flyTo: "영역으로 화면 이동",
      clear: "필터 해제",
      empty: "선택한 영역에 사진·영상이 없습니다",
      emptyHint: "다른 영역을 그리거나 전체 목록으로 돌아가세요",
      emptyNoPositioned:
        "위치가 지정된 사진·영상이 없습니다. 아래 위치 없음 그룹에서 위치를 지정하세요",
      showAll: "전체 목록 보기",
      unpositionedTag: "범위와 무관",
      unpositionedDesc: "위치를 지정하면 범위 안/밖에 따라 목록에 나타납니다",
      placedOutside: "영역 밖에 지정되어 목록에는 보이지 않습니다",
      dropWhileDrawing: "영역을 그리는 중에는 업로드할 수 없습니다",
    },
    usage: {
      title: "사용 용량",
    },
  },
  equipment: {
    menu: "장비·시설",
    title: "장비·시설",
    totalCount: "전체 {{count}}개",
    showOnMap: "지도에 표시",
    listLabel: "장비·시설",
    add: "장비·시설 추가",
    addFolder: "폴더 추가",
    captureView: "화면 캡처",
    captureFormat: "이미지 형식",
    loading: "장비·시설 불러오는 중",
    loadFailedTitle: "장비·시설을 불러오지 못했습니다",
    loadFailedDesc: "잠시 후 다시 시도해 주세요.",
    refreshFailed: "장비·시설 목록을 새로 고치지 못했습니다",
    dock: {
      label: "장비·시설",
      close: "장비·시설 목록 닫기",
      collapse: "접기",
      all: "전체",
      categories: "장비·시설 분류",
      types: "장비·시설 종류",
      prev: "이전 장비·시설",
      next: "다음 장비·시설",
      loadFailed: "장비 종류를 불러오지 못했습니다",
      refreshFailed: "장비 종류를 새로 고치지 못했어요",
      empty: "추가할 수 있는 장비·시설이 없어요",
    },
    catalog: {
      category: {
        lifting: "양중·고소",
        earthwork: "토공·운반",
        temporary: "가설",
        material: "자재",
        labor: "인력",
      },
      type: {
        towerCrane: "타워크레인",
        mobileCrane: "이동식 크레인",
        aerialPlatform: "고소작업대",
        excavator: "굴삭기",
        dumpTruck: "덤프트럭",
        mixerTruck: "레미콘",
        loader: "로더",
        roller: "롤러",
        concretePump: "펌프카",
        drillRig: "천공기",
        forklift: "지게차",
      },
    },
    intro: {
      title: "장비·시설을 미리 움직여 보세요",
      riskTag: "위험",
      speedTag: "{{speed}} km/h",
      realSizeTitle: "실제 크기",
      realSizeDesc: "실제 치수의 모형으로 놓여요",
      reachTitle: "작업반경 확인",
      reachDesc: "겹치는 작업반경을 미리 확인해요",
      simulationTitle: "시뮬레이션",
      simulationDesc: "원하는 동선과 속도로 움직여 봐요",
    },
    list: {
      risk: "위험 {{count}}",
      toggleVisibility: "{{name}} 지도에 표시",
      expand: "{{name}} 펼치기",
      rowMenu: "{{name}} 더보기",
      visibilityFailed:
        "지도 표시를 바꾸지 못했어요. 잠시 후 다시 시도해 주세요",
      moveTo: "해당 위치로 이동",
      rename: "이름 바꾸기",
      delete: "삭제",
      duplicate: "복제",
      duplicateSuffix: " (복사)",
      duplicateFailed: "장비·시설을 복제하지 못했어요. 잠시 후 다시 시도해 주세요",
      duplicateFolderFailed: "폴더를 복제하지 못했어요. 잠시 후 다시 시도해 주세요",
      deleteFolderFailed: "폴더를 삭제하지 못했어요. 잠시 후 다시 시도해 주세요",
      captureFailed: "화면을 캡처하지 못했어요. 잠시 후 다시 시도해 주세요",
      renameInput: "{{name}} 이름",
      renameConfirm: "{{name}} 이름 저장",
      renameCancel: "{{name}} 이름 바꾸기 취소",
      renameFailed: "이름을 바꾸지 못했어요. 잠시 후 다시 시도해 주세요",
      deleteFailed: "장비·시설을 지우지 못했어요. 잠시 후 다시 시도해 주세요",
      deleteTitle: "장비·시설 삭제",
      deleteMessage: "'{{name}}'을(를) 삭제할까요?",
      deleteSubMessage: "삭제한 장비·시설은 되돌릴 수 없어요.",
      deleteCancel: "취소",
      deleteConfirm: "삭제",
    },
    detail: {
      tabs: "{{name}} 상세",
      tab: {
        spec: "규격",
        position: "위치·방향",
        route: "동선",
      },
      cancel: "취소",
      apply: "적용",
      position: "위치",
      moveOnMap: "지도에서 옮기기",
      longitude: "경도",
      latitude: "위도",
      altitude: "높이",
      heading: "바라보는 방향",
      headingInput: "바라보는 방향(도)",
      moving: "옮기는 중",
      origin: "원래 위치",
      specFailed: "규격을 저장하지 못했어요. 잠시 후 다시 시도해 주세요",
      headingFailed: "방향을 저장하지 못했어요. 잠시 후 다시 시도해 주세요",
      moveFailed: "위치를 옮기지 못했어요. 잠시 후 다시 시도해 주세요",
    },
    route: {
      emptyTitle: "아직 동선이 없습니다",
      emptyBody: "지도에 점을 찍어 동선을 그리세요.",
      draw: "동선 그리기",
      drawing: "동선 그리는 중",
      editing: "동선 수정 중",
      cancel: "취소",
      done: "완료",
      distance: "거리",
      points: "지점",
      pointsLimit: "동선 지점은 최대 {{max}}개까지 찍을 수 있어요",
      duration: "예상 시간",
      meters: "{{distance}} m",
      play: "동선 재생",
      pause: "일시정지",
      repeat: "반복 재생",
      repeatShort: "반복",
      position: "재생 위치",
      positionValue: "{{elapsed}} / {{total}}",
      speed: "속도",
      speedSlider: "재생 속도",
      simulation: "동선 시뮬레이션",
      speedUnit: "km/h",
      edit: "수정",
      delete: "삭제",
      locked: "동선 재생을 멈추면 수정 가능합니다.",
      deleteTitle: "동선 삭제",
      deleteMessage: "'{{name}}'의 동선을 삭제하시겠습니까?",
      deleteSubMessage: "삭제한 동선은 복구할 수 없습니다.",
      deleteCancel: "취소",
      deleteConfirm: "삭제",
      saveFailed: "동선을 저장하지 못했어요. 잠시 후 다시 시도해 주세요",
      deleteFailed: "동선을 삭제하지 못했어요. 잠시 후 다시 시도해 주세요",
    },
    placement: {
      createFailed: "장비·시설을 놓지 못했어요. 잠시 후 다시 시도해 주세요",
      name: "이름",
      spec: "기준 규격",
      custom: "직접 입력",
      dimensions: "치수",
      length: "전장",
      width: "전폭",
      height: "전고",
      reach: "작업반경",
      unit: "m",
      radiusColor: "반경 색상",
      radiusColorDisabled: "작업반경이 있어야 고를 수 있어요",
      close: "닫기",
      place: "배치",
      error: {
        nameRequired: "이름을 입력해 주세요",
        nameTooLong: "이름은 {{max}}자까지 쓸 수 있어요",
        dimensionRange: "0보다 크고 {{max}} 이하로 입력해 주세요",
        reachRange: "0~{{max}} 사이로 입력하거나 비워 두세요",
      },
    },
    radiusColor: {
      peach: "피치",
      lemon: "레몬",
      mint: "민트",
      lavender: "라벤더",
      pink: "핑크",
    },
  },
} as const;

export default timeSeries;
